export default __webpack_public_path__ + "a18413265290744ac7049e67331d29ee.png";